let css = require('./bitrix-export-leads.css');
const ProgressBar = require('./progress-bar');
const ActionPanel = require('./action-panel');
const Header = require('../header');
const FieldMapping = require('./field-mapping');
const ErrorTooltip = require('./error-tooltip');
const RequiredFieldsMapping = require('./required-fields-mapping');
const { Checkbox } = require('../../../../../packages/account-ui');
const { setIncludeExportedFreeLeads } = require('../../../../../signals/bitrix');

class OrdersOptions {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: OrdersOptions,
    children: [
        {
            name: 'progress-bar',
            component: ProgressBar
        },
        {
            name: 'header',
            component: Header,
            props: {
                hidePrice: true
            },
            watcher: {
                id: ['account', 'orders', 'currentOrder', 'id'],
                createDate: ['account', 'orders', 'computed', 'currentOrder', 'createDate'],
                stateName: ['account', 'orders', 'computed', 'currentOrder', 'stateName']
            }
        },
        {
            name: 'action-panel',
            component: ActionPanel,
            watcher: {
                isExportRunning: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'exportLeadsProgressLock'],
                mappingError: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isError'],
                isExportDone: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isExportDone'],
                domain: ['bitrix', 'domain']
            }
        },
        {
            name: 'field-mapping',
            component: FieldMapping,
            watcher: (attributes) => ({
                id: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'],
                    'id'],
                isNew: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'],
                    'isNew'],
                hasFieldCreationRight: ['account', 'orders', 'currentOrder', 'bitrixExportLeads',
                    'hasFieldCreationRight']
            })
        },
        {
            name: 'error-tooltip',
            component: ErrorTooltip,
            watcher: {
                isTitleNotFilled: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'missRequiredFields'],
                mappingDuplicate: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'duplicateError']
            }
        },
        {
            name: 'checkbox',
            component: Checkbox,
            props: {
                signal: setIncludeExportedFreeLeads
            },
            watcher: {
                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'isIncludeExportedFreeLeads']
            }
        },
        {
            name: 'required-fields-mapping',
            component: RequiredFieldsMapping,
            watcher: {
                requiredBitrixFields: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'requiredBitrixFields']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/bitrix-export-leads/index.js